import React from "react";
import { FaFacebookF, FaWhatsapp, FaGithub } from "react-icons/fa";
import styles from "../styles/footer.module.css";


function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <p>&copy; {new Date().getFullYear()} 21st Bournemouth Website. All rights reserved.</p>
        <div className={styles.socialIcons}>
          <a href="https://www.facebook.com/21stBmthScouts?locale=en_GB" target="_blank" rel="noopener noreferrer">
            <FaFacebookF />
          </a>
          <a href="https://github.com/oliverwhittle" target="_blank" rel="noopener noreferrer">
            <FaGithub />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;